export default "__VITE_ASSET__CmdU2n2k__"